import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export default function Copyright(props) {
  const { isSmallScreen } = useResponsiveScreen();
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
      sx={{ color: '#212636', fontSize: isSmallScreen ? '0.65rem' : '0.8rem' }}
    >
      {'Copyright © '}
      <Link color="inherit" href="/">
        Algor Leap Solutions
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}
